import { graphql } from "../gql";


export const bootstrapQuery = graphql(`#graphql
	query Bootstrap {
		...authServiceActiveUser
		...billingServiceData
		...referenceServiceData
		...translationServiceData
	}
`);